import {
  memo,
  useState,
  type DetailedHTMLProps,
  type InputHTMLAttributes,
  type ReactNode,
} from 'react';
import { Search as SearchIcon } from '@shared/assets/index';
import { IconButton } from '@shared/ui/index';
import {
  SCloseForSearch,
  SError,
  SInput,
  SLeftIconWrapper,
  SRightIconWrapper,
  SSearchIcon,
  SWrapper,
} from './styles';

export type SearchInputPT = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  isOpenInit?: boolean;
  isClosable?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  isDelegatedControl?: boolean;
  isOpen?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  error?: string;
  rightButtonWrapperClassName?: string;
  leftButtonWrapperClassName?: string;
  inputClassName?: string;
};

export const SearchInput = memo(
  ({
    isClosable = true,
    onClose,
    onOpen,
    isDelegatedControl,
    isOpen,
    isOpenInit = false,
    leftIcon,
    rightIcon,
    error,
    type,
    children, // may be anything u want (prefer DropDown)
    value,
    className,
    rightButtonWrapperClassName,
    leftButtonWrapperClassName,
    inputClassName,
    ...props
  }: SearchInputPT) => {
    const [isOpenDefault, setIsOpenDefault] = useState(isOpenInit);

    const doOpen = () => setIsOpenDefault(true);

    const doClose = () => setIsOpenDefault(false);

    const renderedLeftIcon = leftIcon || <SSearchIcon />;
    const renderedRightIcon = rightIcon || <SCloseForSearch />;

    return (isDelegatedControl ? isOpen : isOpenDefault) ? (
      <div className={className}>
        <SWrapper>
          <SInput type="text" value={value} error={error} className={inputClassName} {...props} />

          <SLeftIconWrapper error={error} className={leftButtonWrapperClassName}>
            {renderedLeftIcon}
          </SLeftIconWrapper>

          {isClosable && (
            <SRightIconWrapper
              className={rightButtonWrapperClassName}
              onClick={() => {
                isDelegatedControl ? onClose && onClose() : doClose();
              }}
            >
              {renderedRightIcon}
            </SRightIconWrapper>
          )}

          {error ? <SError>{error}</SError> : children}
        </SWrapper>
      </div>
    ) : (
      <IconButton
        variant="dark"
        onClick={() => {
          isDelegatedControl ? onOpen && onOpen() : doOpen();
        }}
      >
        <SearchIcon />
      </IconButton>
    );
  }
);
